import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { mobile } from '../styles';
var Wrapper = styled.div.withConfig({
  displayName: "ProductBrowserSideBar__Wrapper",
  componentId: "sc-14z2x21-0"
})(["\n  flex: 0 0 268px;\n  margin-right: 32px;\n  color: #333333;\n\n  ", ";\n"], mobile(_templateObject || (_templateObject = _taggedTemplateLiteral(["display: none;"]))));
export default function ProductBrowserSideBar(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(Wrapper, rest, children);
}
ProductBrowserSideBar.propTypes = {
  children: PropTypes.node
};